import { Ot7Game } from '~/src/models/Ot7Game';
import { Ot7SeasonsOt7Player } from '~/src/models/Ot7Season';
import { Ot7Team } from '~/src/models/Ot7Team';
import { OvertimeEntity } from '~/src/overtime-lib/src/models';

export interface Ot7Player extends OvertimeEntity {
	is_current: boolean;
	is_featured: boolean;
	is_ot7: boolean;
	family_name?: string;
	first_name?: string;
	full_name?: string;
	biography?: string;
	position?: string;
	hometown?: string;
	jersey_number?: string;
	height?: number;
	weight?: number;
	birthdate?: string;
	graduation_year?: number;
	ot7_team_id?: string;
	image_path?: string;
	hero_image_path?: string;
	potential_colleges?: string[];
	committed_college?: string;

	ot7_games_ot7_players_ot7_teams: Ot7GamesOt7PlayersOt7Team[];
	ot7_team: Ot7Team;
	ot7_seasons_ot7_players: Ot7SeasonsOt7Player[];
}

export interface Ot7GamesOt7PlayersOt7Team
	extends OvertimeEntity,
		Ot7PlayerStatistics,
		Ot7GamePlayerStatistics,
		Ot7GamePlayerStatuses {
	ot7_game_id: string;
	ot7_player_id: string;
	ot7_team_id: string;

	ot7_game: Ot7Game;
	ot7_player: Ot7Player;
	ot7_team: Ot7Team;
}

export interface Ot7PlayerStatistics {
	touchdowns?: number;
	rushing_yards?: number;
	passing_yards?: number;
	receiving_yards?: number;
	pass_attempts?: number;
	pass_completions?: number;
	receptions?: number;

	minutes?: number;
	points?: number;
	turnovers?: number;
}

export interface Ot7GamePlayerStatistics {}

export interface Ot7GamePlayerStatuses {
	active?: boolean;
	captain?: boolean;
	did_not_play_reason?: string;
	is_player?: boolean;
	is_team_official?: boolean;
	participated?: boolean;
	playing_position?: string;
	pno?: string;
	shirt_number?: string;
	starter?: boolean;
}

export const getHighSchoolYear = (graduation_year: number) => {
	const years = [
		{ graduation_year: 2025, name: 'Senior' },
		{ graduation_year: 2026, name: 'Junior' },
		{ graduation_year: 2027, name: 'Sophomore' },
		{ graduation_year: 2028, name: 'Freshman' },
		{ graduation_year: 2029, name: '8th Grade' },
		{ graduation_year: 2030, name: '7th Grade' },
	];
	return years.find((y) => y.graduation_year === graduation_year)?.name;
};
